export interface MSItem {
    type: string,
    number: string,
}

export function processReportJson(data: any): any[] {

    let json: any[] = [];

    let map = new Map();
    data.forEach((it: any) => {
        if (!map.has(it.msName)) {
            map.set(it.msName, []);
        }
        let values = map.get(it.msName);
        values.push(it);

        map.set(it.msName, values);
    });

    let totalsMap = new Map();
    map.forEach((value, key) => {
        let obj: any = {};
        obj["MS Name"] = key;
        value.forEach((it: any) => {

            //obj["MS Code"] = it.msCode;
            obj["SAP Code"] = it.msSapId;
            obj["Vendor SAP Code"] = it.msVendorId;
            if (it.type !== 'MS Code' && it.type !== 'MS Name') {
                if (it.type === 'FUEL') {
                    it.totalFuel = checkAmount(it.totalFuel);
                    it.totalRefuel = checkAmount(it.totalRefuel);
                    totalsMap.set(it.type, (totalsMap.get(it.type) || 0.0) + (it.totalFuel as number || 0.0))
                    totalsMap.set("REFUEL", (totalsMap.get("REFUEL") || 0.0) + (it.totalRefuel as number || 0.0))
                } else {
                    it.totalAmount = checkAmount(it.totalAmount);
                    totalsMap.set(it.type, (totalsMap.get(it.type) || 0.0) + (it.totalAmount as number || 0.0))
                }
            }
            if (it.type === 'FUEL') {
                obj[it.type] = (obj[it.type] | 0.0) + (it.totalFuel as number | 0.0);
                obj["REFUEL"] = (obj["REFUEL"] | 0.0) + (it.totalRefuel as number | 0.0);
            } else {
                //it.totalAmount = checkAmount(it.totalAmount);
                obj[it.type] = (obj[it.type] | 0.0) + (it.totalAmount as number | 0.0);
            }
            it.totalAmountInvoices = checkAmount(it.totalAmountInvoices);

        });
        json.push(obj);
    });

    let finalObj: any = {};
    finalObj["MS Name"] = '';
    //finalObj["MS Code"] = '';
    finalObj["SAP Code"] = '';
    finalObj["Vendor SAP Code"] = '';
    totalsMap.forEach((value, key) => {
        finalObj[key] = value;
    })

    json.push(finalObj);
    console.log(json);

    return json;
}

function checkAmount(amount: number): number {

    if (Math.abs(amount) > 0) {
        let res = amount / 100;
        return res;
    }
    return amount;
}

export function downloadFilePdf(pdf: string, fileName: any) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}
